import { SVGProps, Ref, forwardRef } from 'react';

export const TelegramGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.962 7.204Q7.601 4.779 9.48 4.007c3.58-1.47 4.324-1.726 4.81-1.734.106-.002.344.024.499.148.13.104.166.245.183.344.017.1.039.325.022.501-.194 2.013-1.034 6.897-1.46 9.15-.182.954-.537 1.274-.882 1.306-.748.068-1.317-.489-2.042-.958-1.135-.734-1.776-1.191-2.877-1.908-1.273-.828-.448-1.283.278-2.027.19-.195 3.488-3.157 3.552-3.425.008-.034.015-.16-.06-.225-.075-.067-.187-.044-.267-.026q-.17.039-5.438 3.548-.771.525-1.398.51c-.46-.01-1.345-.257-2.004-.468-.807-.259-1.448-.396-1.393-.836q.045-.345.96-.703"
            fill="#919191"
        />
    </svg>
));
TelegramGrayscaleSize16Glyph.displayName = 'TelegramGrayscaleSize16Glyph';
